export const rashod_imovine = {
    templateId: 209.3,
    category: 4,
    templateTitle: 'Odluka o rashodu materijalne imovine',
    templateDescription: `<p>Ukoliko određena dugotrajna materijalna imovina nije više za upotrebu, poduzetnik donosi odluku o njezinom rashodovanju, sve u skladu s poreznim propisima. </p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Kada određena dugotrajna materijalna imovina nije više za upotrebu, ovlašteno tijelo, u praksi najčešće zakonski zastupnik, treba donijeti odluku o njezinom rashodovanju.     </p>
    <p>Pitanje rashodovanja neupotrebljivih predmeta dugotrajne nefinancijske imovine poželjno je riješiti prije godišnjeg popisa, tijekom godine, najbolje u trenutku kada nastanu razlozi za prestanak upotrebe nekog sredstva. Rashodovana sredstva se nakon toga mogu uništiti ili otuđiti i na taj način više neće fizički postojati u vrijeme obavljanja godišnjeg popisa, pa njime niti neće biti obuhvaćena.    </p>
    <p>Ipak, rashodovanje imovine se često provodi nakon provedenog popisa imovine i obveza (inventura).</p>
    <p>Ako se neupotrebljiva sredstva ne rashoduju prije obavljanja godišnjeg popisa, rashodovanje dugotrajne imovine provodi se na temelju Prijedloga povjerenstva za rashodovanje imovine koji utvrđuje vrstu i količinu imovine koju je potrebno rashodovati i razloge koji su doveli do neuporabljivosti predmetne imovine. Dakle, ako je ta imovina konstatirana godišnjim popisom, ona se ne isknjižava iz poslovnih knjiga koje se zaključuju s 31. prosincem godine za koju je obavljen godišnji popis.  </p>
    <p>Važno je naglasiti da na temelju odluke o rashodovanju nije dozvoljeno isknjiženje rashodovane dugotrajne materijalne imovine iz knjigovodstvene evidencije, nego se isknjiženje obavlja ovisi temeljem odluke o uništenju ili odluke o otuđenju ove rashodovane imovine.   </p>
    <p>U slučaju uništenja, dokument za isknjiženje je komisijski zapisnik o uništenju rashodovane imovine potvrdi o odvozu na otpad, a u slučaju otuđenja dokument kojim se utvrđuje prodaja, darovanje i sl..    </p>
    <p>Nalog za uništenje ili zbrinjavanje dobara može dati i odgovarajuća inspekcijska služba. U tome slučaju, porezni obveznik treba raspolagati dokumentacijom tih službi (inspekcije ili drugih nadležnih tijela) iz koje se nedvojbeno može utvrditi da je roba takve kvalitete da se ne može isporučiti ili uzeti za vlastitu potrošnju, te da je uništena, odnosno dana na zbrinjavanje. </p>
    <p>Ako društvo iz bilo kojeg razloga nije u mogućnosti pribaviti odgovarajuću Potvrdu od strane nadležnog društva koje skuplja otpad ili bilo kakav dokument kojim se može dokazati da je rashodovana imovina uništena, treba se obratiti Poreznoj upravi, odnosno podnijeti Zahtjev za prisutnost pri uništenju dugotrajne materijalne imovine.    </p>
    <p>Tako propisuje Pravilnik o porezu na dodanu vrijednost u kojemu se navodi da se manjak dobara zbog neodgovarajuće kvalitete, proteka roka trajanja, kala, rastepa, loma i kvara iznad visine određene odlukama Obrtničke ili Gospodarske komore, može priznati, ako je pri utvrđivanju činjeničnog stanja prisutan ovlašteni službenik Porezne uprave ili ako porezni obveznik raspolaže odgovarajućom dokumentacijom nadležnih tijela ili pravnih osoba o količini i vrsti preuzetih dobara koja su dana na zbrinjavanje ili uništenje.    </p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Pravilnika o proračunskom računovodstvu i Računskom planu,   Zakon o porezu na dodanu vrijednost.</p>
    
    `,
  
    sides: [
        {
            signature: 'Za Poduzetnika',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Poduzetnik),',
        }
    ],

    
    headline: '​donosi sljedeću',
    title: 'ODLUKA O RASHODU MATERIJALNE IMOVINE',
    noArticleNumbers: true,

    articles: [
     
      {
        title: '',
        mandatory: false,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                editable: true,
                mandatory: true,
                content: 'Nakon provedene inventure, Popisnim listom br.____________od _____________ godine obuhvaćeno je stanje robe - materijala te je istim utvrđen manjak prema tablici koja se nalazi u Privitku ove Odluke. ',
                value: '',
            }],
    },
    {
      title: '',
      mandatory: false,
      exampleContent: true,
      statements: [
          {
              type: 'text',
              editable: true,
              mandatory: true,
              content: 'Temeljem prijedloga povjerenstva za rashodovanje imovine predlaže se rashodovanje sljedeće imovine: \r\n 1) _________________, \r\n- trošak nabave ______ kn,  \r\n- akumulirana amortizacija ______ kn, \r\n- knjigovodstvena vrijednost ______ kn.',
              value: '',
          }],
  },
    {
      title: '',
      mandatory: false,
      dummy: true,
      exampleContent: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          help: "Za svaki otpis potrebno je posebno obrazložiti točno određeni razlog razloge koji su doveli do neuporabljivosti predmetne imovine.",
          content: `PRIMJER BR. 1. \r\n"Uređaji su neispravni, pa se isključuju iz uporabe i bit će odvezeni na otpad trgovačkom društvu XY d.o.o. koje obavlja djelatnost zbrinjavanja elektroničke opreme.\r\nO tome će Društvo pribaviti odgovarajuću potvrdu.\r\nU slučaju da ovlašteni sakupljač elektroničkog otpada ne preuzme uređaj na zbrinjavanje, biti će pribavljena suglasnost Porezne uprave kako bi se isknjiženje te imovine moglo porezno priznati.\r\nDokument kojim se pravda Odluka o isknjižavanju rashodovane imovine je Potvrda o primljenom otpadu od strane ovlaštenog sakupljača otpada ili suglasnost Porezne uprave."`,
        }]
    },
    {
      title: '',
      mandatory: false,
      dummy: true,
      exampleContent: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          help: "Za svaki otpis potrebno je posebno obrazložiti točno određeni razlog razloge koji su doveli do neuporabljivosti predmetne imovine.",
          content: `PRIMJER BR. 2. \r\n"Uređaj na nabavljen po vrijednosti od ___ kn, sadašnja vrijednost je ___ kn.\r\nUređaj će se ponuditi na tržištu te će se pokušati prodati prema početnoj procijenjenoj cijeni od ___ kn.\r\nDokument kojim se pravda Odluka o isknjižavanju rashodovane imovine je izlazni račun. "`,
        }]
    },
    {
      title: '',
      mandatory: false,
      dummy: true,
      exampleContent: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          help: "Za svaki otpis potrebno je posebno obrazložiti točno određeni razlog razloge koji su doveli do neuporabljivosti predmetne imovine.",
          content: `PRIMJER BR. 3. \r\n"Uređaj na nabavljen po vrijednosti od ___ kn, sadašnja vrijednost je ___ kn.\r\nUređaj će se darovati, a o čemu će se donijeti posebna odluka. \r\nDokument kojim se pravda Odluka o isknjižavanju rashodovane imovine zapisnik o primopredaji imovine odnosno otpremnica."`,
        }]
    },
  {
    title: '',
    mandatory: false,
    statements: [
        {
            type: 'text',
            required: true,
            mandatory: true,
            editable: true,
            content: 'Ova Odluka primjenjuje se od trenutka donošenja.',
            value: '',
        },
    ],
    value: '',
}, 

{
  mandatory: true,
  static: true,
  type: 2, // date and place
  statements: [
    {
      type: "input",
      mandatory: true,
      parts: [
        {
          type: "text",
          content: "U"
        },
        {
          type: "input",
          value: "",
          placeholder: "Upišite mjesto.",
          required: true,
        },
        {
          type: "text",
          content: ", dana"
        },
        {
          type: "date",
          value: new Date(),
          required: true
        },
        {
          type: "text",
          content: "godine."
        }
      ]
    },
  ]
},
{
  mandatory: true,
  static: true,
  type: 3,  // signature
  statements: [],
},
{
  static: true,
  mandatory: false,
  type: 4, 
  statements: [
    {
      type: 'text',
      mandatory: true,
      editable: true,
      content: 'Dostaviti:\r\n1) Članovima inv. komisije \r\n2) Odjel knjigovodstva',
      help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
    }
  ]
},
],
};






// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/209.3_rashod_imovine.ts